import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Row,
  Col,
  InputGroupText, InputGroup
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { get, handleApiError, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { parseErrors } from "../../helpers/api_error_parser"
import { useParams } from "react-router-dom"

const UserForm = (props) => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    plainPassword: "",
    role: "",
  });

  const [roles, setRoles] = useState([]); // Liste des rôles à récupérer depuis l'API
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const roleIri = '/v1/api/role-user-stores/';

  const fetchRoles = async () => {
    const responseRoles = await get('role-user-stores');

    if (200 === responseRoles.status) {
      setRoles(responseRoles.data['hydra:member']);
    }
  }

  const fetchUserStore = async (id) => {
    const responseUserStore = await get(`user-stores${id}`);
    console.log(responseUserStore);
  }

  // Charger la liste des rôles depuis l'API
  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    if (id) {
      fetchUserStore(id);
    }
  }, [id]);



  // Gestion des changements de formulaire
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess(null);

    const postData = {
      user: {
        email: formData.email,
        fullName: formData.fullName,
        plainPassword: formData.plainPassword,
      },
      role: roleIri + formData.role, // IRI du rôle
    };

    try {
      const response = await post('user-stores', postData);
      if (201 === response.status) {
        setSuccess("Utilisateur créé avec succès !");
        setFormData({ email: "", fullName: "", plainPassword: "", role: "" });
      } else {
        setErrors(parseErrors(response.error));
      }
    } catch (error) {
      setErrors(parseErrors(error.response.data));
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Créer un compte utilisateur")}
                       breadcrumbItem={props.t("Créer un compte utilisateur")} />
          <div className="mt-2">
            <Card className="shadow">
              <CardBody>
                <p className="text-muted">Remplissez le formulaire ci-dessous pour ajouter un nouvel utilisateur.</p>
                {
                  errors && errors.length > 0 && (
                    <div className="alert alert-danger">
                      {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </div>
                  )
                }
                {success && <Alert color="success">{success}</Alert>}

                <Form onSubmit={handleSubmit}>
                  {/* Première ligne (Email + Nom complet) */}
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Entrez l'email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          autoComplete={false}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="fullName">Nom complet</Label>
                        <Input
                          type="text"
                          name="fullName"
                          id="fullName"
                          placeholder="Entrez le nom complet"
                          value={formData.fullName}
                          onChange={handleChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="role">Rôle</Label>
                        <Input
                          type="select"
                          name="role"
                          id="role"
                          value={formData.role}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Sélectionnez un rôle</option>
                          {roles.map((role) => (
                            <option key={role.id} value={role.id}>
                              {role.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end mt-3">
                    <Button color="primary" type="submit">
                      <i className="bx bx-check-circle"></i> Créer l'utilisateur
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(UserForm);
